const KB = 1024;
const MB = 1024 * KB;

export const ATTACHMENT_ALLOWED_EXTENSIONS = [
  '.jpg',
  '.jpeg',
  '.png',
  '.webp',
  '.pdf',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
] as const;

export const IMAGE_ALLOWED_EXTENSIONS = [
  '.jpg',
  '.jpeg',
  '.png',
  '.webp',
] as const;

export const KB_IMPORT_ALLOWED_EXTENSIONS = [
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
] as const;

export const ATTACHMENT_ACCEPT = ATTACHMENT_ALLOWED_EXTENSIONS.join(',');
export const IMAGE_ACCEPT = IMAGE_ALLOWED_EXTENSIONS.join(',');
export const KB_IMPORT_ACCEPT = KB_IMPORT_ALLOWED_EXTENSIONS.join(',');

export const MAX_ATTACHMENT_SIZE_BYTES = 100 * MB;
export const MAX_EMAIL_ATTACHMENT_SIZE_BYTES = 10 * MB;
export const MAX_EMAIL_ATTACHMENTS = 5;
export const MAX_KB_IMAGE_SIZE_BYTES = 5 * MB;
/** Imagens do deck CAB (PPT visual): alinhado ao backend MAX_CAB_DECK_IMAGE_FILE_SIZE. */
export const MAX_CAB_DECK_IMAGE_SIZE_BYTES = 2 * MB;
export const MAX_KB_IMPORT_SIZE_BYTES = 25 * MB;

const normalizeExtension = (filename: string): string => {
  const idx = filename.lastIndexOf('.');
  if (idx < 0) return '';
  return filename.slice(idx).toLowerCase().trim();
};

const formatAllowed = (allowedExtensions: readonly string[]): string =>
  allowedExtensions.join(', ');

const toMb = (sizeInBytes: number): number => Math.floor(sizeInBytes / MB);

const validateFileBase = (
  file: File,
  allowedExtensions: readonly string[],
  maxSizeBytes: number,
): string | null => {
  const ext = normalizeExtension(file.name || '');
  if (!ext || !allowedExtensions.includes(ext as (typeof allowedExtensions)[number])) {
    return `Tipo de arquivo inválido. Formatos permitidos: ${formatAllowed(allowedExtensions)}.`;
  }
  if (file.size > maxSizeBytes) {
    return `Arquivo muito grande. Tamanho máximo permitido: ${toMb(maxSizeBytes)}MB.`;
  }
  return null;
};

export const validateAttachmentFile = (file: File): string | null =>
  validateFileBase(file, ATTACHMENT_ALLOWED_EXTENSIONS, MAX_ATTACHMENT_SIZE_BYTES);

export const validateEmailAttachmentFile = (file: File): string | null =>
  validateFileBase(file, ATTACHMENT_ALLOWED_EXTENSIONS, MAX_EMAIL_ATTACHMENT_SIZE_BYTES);

export const validateAttachmentFiles = (files: File[]): string | null => {
  for (const file of files) {
    const error = validateAttachmentFile(file);
    if (error) return error;
  }
  return null;
};

export const validateKbImageFile = (file: File): string | null =>
  validateFileBase(file, IMAGE_ALLOWED_EXTENSIONS, MAX_KB_IMAGE_SIZE_BYTES);

export const validateCabDeckImageFile = (file: File): string | null =>
  validateFileBase(file, IMAGE_ALLOWED_EXTENSIONS, MAX_CAB_DECK_IMAGE_SIZE_BYTES);

export const validateKbImportFile = (file: File): string | null =>
  validateFileBase(file, KB_IMPORT_ALLOWED_EXTENSIONS, MAX_KB_IMPORT_SIZE_BYTES);
